import React, { useState } from "react"
import { selectIcon, SVG } from "../../../../components/UI/selector"
import {
  changeVolume,
  getAudioVolume,
  getDefaultValue,
  InputRange,
} from "../../../../components/UI/InputRange/InputRange"
import "./AVScontrols.scss"

export default function AVControls({
  controlClick,
  required,
  zoom,
  zoomData,
  selfData,
  value,
  id,
  soundSetting,
  ...props
}) {
  return (
    <div className="AVControls">
      <Icon
        disable={zoomData && zoomData.OvAudioId}
        status={zoom && !zoom.getLocalMuteStatus()}
        icon="audio"
        onClick={(e) => controlClick("audio")}
      />
      <Icon
        disable={zoomData && zoomData.OvCameraId}
        status={zoom && zoom.getLocalVideoStatus()}
        icon="video"
        onClick={(e) => controlClick("camera")}
      />
      {!soundSetting === 'default' ?
        <Volume icon="volume" value={value} id={id} />
        : ''}

    </div>
  )
}

const Volume = ({ icon, id }) => {
  const [mute, setMute] = useState(getDefaultValue().status)
  const checkMute = getAudioVolume(id)
  return (

    <div className={`stats_icon_volume${checkMute ? "" : " active"}`}>
      <InputRange max={100} min={0} step={1} id={id} setMute={setMute} />

      <div className="stats_icon_volume_iconDiv">
        <SVG
          className={icon}
          src={selectIcon(`${checkMute ? "no" : ""}${icon}`)}
          onClick={() => {
            console.log("checkMute", checkMute)
            changeVolume(checkMute ? 100 : 0, id, true, setMute)
          }}
        />
      </div>

    </div>

  )
}

const Icon = ({ status, icon, onClick, disable }) => {
  // const icons = `${status ? '' : 'no'}${icon}`;
  return (
    <div
      className={`stats_icon ${disable ? " disable" : status ? " active" : ""}`}
      onClick={() => (!disable ? onClick(!status) : null)}
    >
      {status ? (
        <SVG className={icon} src={selectIcon(icon)} />
      ) : (
        <SVG className={icon} src={selectIcon(`no${icon}`)} />
      )}
    </div>
  )
}

const MoreIcon = ({ status, onClick }) => (
  <div
    id="more_icon"
    className={`stats_icon ${status ? " active" : ""}`}
    onClick={onClick}
  >
    <SVG className="moreIcon" src={selectIcon(`moreIcon`)} />
  </div>
)
